import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "navigation" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const pages = [
    {
        to: "/projects",
        title: "Projecten",
    },
    {
        to: "/clients",
        title: "Klanten",
    },
    {
        to: "/documents",
        title: "Documenten",
    },
    {
        to: "/employees",
        title: "Werknemers",
    },
    {
        to: "/company",
        title: "Bedrijf",
    },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pages, (page, index) => {
        return _createElementVNode("li", { key: index }, [
          _createVNode(_component_router_link, {
            to: page.to
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(page.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      }), 64))
    ])
  ]))
}
}

})